import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const REVIEW_PRICE = 50;
const WARRANTY_HOURS = 168;
const CHAIN_PRICE = 24;
const CHAIN_ACTION_PRICE = 3.5;

const STEAM_FAQ = [
  {
    title: 'Что такое Steam Wishlist и зачем его продвигать?',
    isH3: true,
    text: (
      <p>
        Steam Wishlist — это список желаемых игр пользователя в платформе Steam.
        <br />
        <br />
        Чем больше пользователей добавляют игру в вишлист, тем выше её видимость в алгоритмах Steam: платформа учитывает добавления в вишлист при ранжировании игр в поиске, рекомендациях и в разделе «Популярное».
        <br />
        <br />
        Boostclick помогает организовать удалённое тестирование страницы вашей игры реальными пользователями Steam.
      </p>
    ),
  },
  {
    title: 'Как работает тестирование?',
    isH3: true,
    text: (
      <div>
        Исполнитель получает задание и:
        <br />
        <br />
        <ol>
          <li>Открывает Steam и находит страницу вашей игры по названию;</li>
          <li>Изучает описание, скриншоты и трейлер;</li>
          <li>Добавляет игру в свой Wishlist;</li>
          <li>При наличии демо — скачивает и запускает;</li>
          <li>Присылает отчёт с подтверждением и своим никнеймом.</li>
        </ol>
      </div>
    ),
  },
  {
    title: 'Можно ли заказать только просмотр страницы без добавления в Wishlist?',
    isH3: false,
    text: (
      <p>
        Да. В режиме ПФ вы сами настраиваете набор действий: можно заказать только изучение описания, просмотр трейлера или подписку на обновления — без добавления в вишлист.
      </p>
    ),
  },
  {
    title: 'Какие гарантии предоставляет Boostclick?',
    isH3: false,
    text: (
      <ul>
        <li>Задание выполняется реальным пользователем Steam вручную;</li>
        <li>У вас есть 72 часа на проверку отчёта;</li>
        <li>Если отчёт не соответствует условиям — запросите замену исполнителя;</li>
        <li>Boostclick не влияет на алгоритмы Steam и не гарантирует рост позиций.</li>
      </ul>
    ),
  },
  {
    title: 'Это накрутка?',
    isH3: false,
    text: (
      <p>
        Нет. Boostclick — платформа для размещения заданий реальным пользователям.
        <br />
        Все действия выполняются людьми вручную на основе личного взаимодействия с вашей игрой.
        <br />
        Мы не используем ботов, скрипты или автоматизацию.
      </p>
    ),
  },
  {
    title: 'Вы работаете с юридическими лицами?',
    isH3: false,
    text: (
      <p>
        Да. Предоставляем акты, счета и закрывающие документы через ЭДО.
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя. Каждый
    сценарий начинается с поиска игры по названию в Steam.
  </p>
);

const ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть Steam', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Ввести название игры в поиск', initialShare: 1 },
  { type: 'ALWAYS.OPEN_GAME', icon: 'click', iconHome: 'home-click', title: 'Открыть страницу игры', initialShare: 1 },
  {
    type: 'MAIN.ADD_WISHLIST',
    icon: 'heart',
    iconHome: 'home-heart',
    title: 'Добавить игру в Wishlist',
    initialShare: 0.8,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Wishlist',
  },
  {
    type: 'MAIN.REVIEW',
    icon: 'message',
    iconHome: 'home-reviews',
    title: 'Оставить отзыв на игру',
    initialShare: 0,
    price: `от ${REVIEW_PRICE}`,
    itemTitle: 'тест+отзыв',
    activityType: 'Отзыв',
  },
  {
    type: 'MAIN.WATCH_TRAILER',
    icon: 'eye',
    iconHome: 'home-eye',
    title: 'Посмотреть трейлер игры',
    initialShare: 0.6,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Трейлер',
  },
  {
    type: 'MAIN.READ_DESCRIPTION',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Изучить описание игры',
    initialShare: 0.5,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Описание',
  },
  {
    type: 'MAIN.FOLLOW',
    icon: 'bell',
    iconHome: 'home-subscribe',
    title: 'Подписаться на обновления игры',
    initialShare: 0,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Подписка',
  },
  {
    type: 'MAIN.RUN_DEMO',
    icon: 'action',
    iconHome: 'home-action',
    title: 'Скачать и запустить демо',
    initialShare: 0,
    pricePerChain: 60,
    activityType: 'Запуск',
  },
  {
    type: 'EXTRA.SCREENSHOTS',
    icon: 'eye',
    iconHome: 'home-eye',
    title: 'Посмотреть скриншоты игры',
    initialShare: 0.4,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Скриншоты',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: 'home-action',
    title: 'Поведенческая активность',
    path: '/povedencheskie-faktory-na-steam',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: 'home-heart',
    title: 'Добавить в Wishlist',
    path: '/povedencheskie-faktory-na-steam',
    target: '_self',
  },
  {
    iconHome: 'home-subscribe',
    title: 'Подписаться на игру',
    path: '/povedencheskie-faktory-na-steam',
    target: '_self',
  },
  {
    iconHome: 'home-eye',
    title: 'Посмотреть трейлер',
    path: '/povedencheskie-faktory-na-steam',
    target: '_self',
  },
  {
    iconHome: 'home-glasses',
    title: 'Изучить описание',
    path: '/povedencheskie-faktory-na-steam',
    target: '_self',
  },
  {
    iconHome: 'home-reviews',
    title: 'Оставить отзыв',
    path: '/reviews-on-steam',
    target: '_self',
  },
];

const STEP_PHRASE_2 = 'Укажите название игры для поиска в Steam';

const STEAM_KEYWORDS = [
  'Steam', 'steam', 'Стим', 'стим', 'Wishlist', 'вишлист',
];

class SteamWishlistClass extends Market {

  id = 'SteamWishlist';
  host = 'store.steampowered.com';
  hostsList = [
    'store.steampowered.com',
    'steampowered.com',
    'steamcommunity.com',
  ];
  url = 'https://store.steampowered.com/';

  title = 'Steam Wishlist';

  isMarketplace = false;
  hasSearchPhrase = true;
  hasNoServicesInReview = true;

  icon = 'steam';
  titlePlaces = 'Steam*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;
  categories = [];

  chainsPerDayNormal = 200 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = STEAM_KEYWORDS;

  targetLinkComment = 'Укажите ссылку на страницу игры в Steam';
  targetLinkCommentShort = 'Укажите ссылку на игру';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/povedencheskie-faktory-na-steam',
      rating: 0.97,
      title: 'ПФ Steam',
      navigateTitle: 'ПФ действия на странице игры в Steam',
      icon: 'lightning',
      iconForHomePage: 'home-action',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ на Steam — Wishlist, просмотры | Boostclick`,
        description: `Продвижение игры в Steam через поведенческие факторы от ${CHAIN_PRICE} руб. — Wishlist, трейлер, подписка.`,
        canonical: '/povedencheskie-faktory-na-steam',
      },
      intro: {
        title: 'Продвижение игры в Steam через ПФ',
        comment: 'Через выполнение микрозадач от реальных пользователей Steam',
        points: [
          'Добавления в Wishlist от реальных аккаунтов',
          'Просмотры трейлера и изучение описания',
          'Подписка на обновления игры',
          'Запуск и тестирование демо-версии',
          'Честные отзывы после взаимодействия с игрой',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры ПФ на странице игры в Steam',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать ПФ на Steam',
      titleFAQ: 'Вопрос-ответ по продвижению игры в Steam Wishlist',
      faq: STEAM_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => !action.type.startsWith('VIEW.') && action.type !== 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Каждый исполнитель получит индивидуальное задание — поиск игры по названию, изучение страницы и выбранные вами действия.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
      ],
    },
    {
      id: MARKET_MODES.REVIEWS,
      path: '/reviews-on-steam',
      rating: 0.97,
      title: 'Отзывы',
      navigateTitle: 'Отзывы на игры в Steam',
      icon: 'message',
      iconForHomePage: 'home-reviews',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Отзывы на игры в Steam от ${REVIEW_PRICE} руб. — ЛЮДИ | Boostclick`,
        description: `Реальные отзывы на игры в Steam от ${REVIEW_PRICE} руб. Исполнитель изучает игру и пишет честный отзыв.`,
        canonical: '/reviews-on-steam',
      },
      intro: {
        title: 'Получить отзыв на игру в Steam',
        comment: 'Тестирование игры реальными пользователями Steam',
        points: [
          'Отзывы от реальных игроков после личного взаимодействия с игрой',
          'Исполнитель: изучает описание → смотрит трейлер → добавляет в Wishlist → пишет отзыв',
          `Оплата только после выполнения задания (до ${WARRANTY_HOURS} часов)`,
          'Электронный чек после оплаты',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры отзыва на игру в Steam',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать отзывы на Steam',
      titleFAQ: 'Вопрос-ответ по отзывам на Steam',
      faq: STEAM_FAQ,
      actions: (() => {
        const pfWithReview = ['MAIN.WATCH_TRAILER', 'MAIN.READ_DESCRIPTION', 'EXTRA.SCREENSHOTS', 'MAIN.ADD_WISHLIST'];
        return [
          ...ACTIONS
            .filter(action => action.type === 'MAIN.REVIEW')
            .map(action => ({ ...action, initialShare: 1 })),
          ...ACTIONS
            .filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.'))
            .map(action => pfWithReview.includes(action.type) ? { ...action, initialShare: 1 } : action),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Оплата — только после подтверждения результата.',
        'Возможность бесплатной замены исполнителя при неудачном размещении отзыва.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на игру в Steam';
  invalidUrlStr = 'Укажите корректную ссылку на игру в Steam';
}

const SteamWishlist = new SteamWishlistClass();
export default SteamWishlist;
